// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cm-table-assign {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  min-width: 0;
}

.cm-table-assign.is-compact {
  gap: 0.28rem;
}

.cm-table-assign__label {
  margin: 0;
  color: var(--cm-muted);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.cm-table-assign__picks {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.cm-table-assign__chip {
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
}

.cm-table-assign__chip.has-cam:not(.is-on) {
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--cm-primary) 55%, transparent);
}

.cm-table-assign__suggest {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  align-self: flex-start;
  margin: 0;
  padding: 0.28rem 0.55rem;
  border: 0;
  border-radius: 999px;
  background: color-mix(in srgb, var(--cm-primary) 22%, transparent);
  color: var(--cm-text);
  font: inherit;
  font-size: 0.72rem;
  font-weight: 700;
  cursor: pointer;
}

.cm-table-assign__suggest:disabled {
  opacity: 0.5;
  cursor: default;
}

.cm-table-assign--matches {
  margin: 0.55rem 0 0;
  padding: 0.7rem 0.75rem 0.75rem;
  border: 1px solid color-mix(in srgb, var(--cm-text) 12%, transparent);
  border-radius: 12px;
  background: color-mix(in srgb, var(--cm-text) 4%, transparent);
}

.cm-table-assign__matches {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.cm-table-assign__match {
  width: 100%;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 0.45rem 0.65rem;
  align-items: center;
  padding: 0.5rem 0.6rem;
  border: 1px solid color-mix(in srgb, var(--cm-text) 12%, transparent);
  border-radius: 10px;
  background: color-mix(in srgb, var(--cm-text) 5%, transparent);
  color: var(--cm-text);
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.cm-table-assign__match strong {
  font-size: 0.82rem;
  font-weight: 800;
}

.cm-table-assign__match span {
  font-size: 0.78rem;
  font-weight: 600;
}

.cm-table-assign__match em {
  font-style: normal;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--cm-muted);
}

.cm-table-assign__match.is-here {
  cursor: default;
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--cm-primary) 50%, transparent);
}

.cm-table-assign__match.is-live em {
  color: var(--cm-primary);
}

.cm-table-assign__match:disabled:not(.is-here) {
  opacity: 0.5;
  cursor: default;
}

.cm-rubber-card__table-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.22rem;
  margin: 0;
  padding: 0.12rem 0.42rem;
  border: 1px solid color-mix(in srgb, var(--cm-text) 16%, transparent);
  border-radius: 999px;
  background: color-mix(in srgb, var(--cm-text) 6%, transparent);
  color: inherit;
  font: inherit;
  font-size: 0.68rem;
  font-weight: 800;
  cursor: pointer;
}

.cm-rubber-card__table-btn.has-cam,
.cm-rubber-card__table-btn.is-on {
  border-color: color-mix(in srgb, var(--cm-primary) 55%, transparent);
}

.cm-rubber-card__table-btn:disabled {
  cursor: default;
}

.cm-rubber-card__assign {
  width: 100%;
  margin-top: 0.35rem;
}

.cm-control-room__assign {
  margin-top: 0.55rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/championship/ChampionshipTableAssign.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kFAAkF;AACpF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,SAAS;EACT,wBAAwB;EACxB,SAAS;EACT,oBAAoB;EACpB,kEAAkE;EAClE,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,qEAAqE;EACrE,mBAAmB;EACnB,8DAA8D;AAChE;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,qEAAqE;EACrE,mBAAmB;EACnB,8DAA8D;EAC9D,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,wBAAwB;EACxB,qEAAqE;EACrE,oBAAoB;EACpB,8DAA8D;EAC9D,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,oEAAoE;AACtE;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".cm-table-assign {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  min-width: 0;\n}\n\n.cm-table-assign.is-compact {\n  gap: 0.28rem;\n}\n\n.cm-table-assign__label {\n  margin: 0;\n  color: var(--cm-muted);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.cm-table-assign__picks {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.cm-table-assign__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n}\n\n.cm-table-assign__chip.has-cam:not(.is-on) {\n  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--cm-primary) 55%, transparent);\n}\n\n.cm-table-assign__suggest {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  align-self: flex-start;\n  margin: 0;\n  padding: 0.28rem 0.55rem;\n  border: 0;\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--cm-primary) 22%, transparent);\n  color: var(--cm-text);\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.cm-table-assign__suggest:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.cm-table-assign--matches {\n  margin: 0.55rem 0 0;\n  padding: 0.7rem 0.75rem 0.75rem;\n  border: 1px solid color-mix(in srgb, var(--cm-text) 12%, transparent);\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--cm-text) 4%, transparent);\n}\n\n.cm-table-assign__matches {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.cm-table-assign__match {\n  width: 100%;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 0.45rem 0.65rem;\n  align-items: center;\n  padding: 0.5rem 0.6rem;\n  border: 1px solid color-mix(in srgb, var(--cm-text) 12%, transparent);\n  border-radius: 10px;\n  background: color-mix(in srgb, var(--cm-text) 5%, transparent);\n  color: var(--cm-text);\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.cm-table-assign__match strong {\n  font-size: 0.82rem;\n  font-weight: 800;\n}\n\n.cm-table-assign__match span {\n  font-size: 0.78rem;\n  font-weight: 600;\n}\n\n.cm-table-assign__match em {\n  font-style: normal;\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--cm-muted);\n}\n\n.cm-table-assign__match.is-here {\n  cursor: default;\n  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--cm-primary) 50%, transparent);\n}\n\n.cm-table-assign__match.is-live em {\n  color: var(--cm-primary);\n}\n\n.cm-table-assign__match:disabled:not(.is-here) {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.cm-rubber-card__table-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.22rem;\n  margin: 0;\n  padding: 0.12rem 0.42rem;\n  border: 1px solid color-mix(in srgb, var(--cm-text) 16%, transparent);\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--cm-text) 6%, transparent);\n  color: inherit;\n  font: inherit;\n  font-size: 0.68rem;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.cm-rubber-card__table-btn.has-cam,\n.cm-rubber-card__table-btn.is-on {\n  border-color: color-mix(in srgb, var(--cm-primary) 55%, transparent);\n}\n\n.cm-rubber-card__table-btn:disabled {\n  cursor: default;\n}\n\n.cm-rubber-card__assign {\n  width: 100%;\n  margin-top: 0.35rem;\n}\n\n.cm-control-room__assign {\n  margin-top: 0.55rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
